<template>
  <v-navigation-drawer
    v-model="drawer"
    :expand-on-hover="expandOnHover"
    :mini-variant="miniVariant"
    :right="$vuetify.rtl"
    mobile-break-point="960"
    app
    width="290"
    class="sidebar-container"
    floating
  >
    <div class="profile-area px-4 pt-6 pb-2">
      <div
        class="d-flex align-center"
        :class="{ 'justify-center': miniVariant }"
      >
        <v-avatar size="50" class="profile-avatar elevation-2">
          <v-img
            src="ovec.png"
            lazy-src="https://via.placeholder.com/50"
            alt="User"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="20"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-avatar>

        <div class="ml-3 overflow-hidden" v-if="!miniVariant">
          <div
            class="text-subtitle-1 font-weight-bold text-truncate text-primary"
          >
            {{ user.user_firstname || "ผู้ใช้งาน" }}
          </div>
          <div class="caption grey--text text--darken-1 text-truncate">
            {{ user.user_name || "ID: Unknown" }}
          </div>
          <div class="d-flex align-center mt-1">
            <v-icon x-small color="success" class="mr-1">mdi-circle</v-icon>
            <span class="caption success--text font-weight-medium"
              >ออนไลน์</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="px-4 mt-2 mb-2" v-if="!miniVariant">
      <v-text-field
        v-model="searchQuery"
        placeholder="ค้นหาเมนู..."
        prepend-inner-icon="mdi-magnify"
        filled
        rounded
        dense
        hide-details
        background-color="grey lighten-4"
        class="search-input"
        @input="filterMenuItems"
      ></v-text-field>
    </div>

    <v-divider class="mx-4 mb-2 mt-1" v-if="!miniVariant"></v-divider>

    <v-list dense nav class="px-2">
      <v-list-item
        to="/college/home_menu"
        color="primary"
        class="mb-1 rounded-lg"
      >
        <v-list-item-icon>
          <v-icon>mdi-home-variant-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium"
            >หน้าแรก</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        to="/college/collegeinfo"
        color="primary"
        class="mb-3 rounded-lg"
      >
        <v-list-item-icon>
          <v-icon>mdi-school-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium"
            >ข้อมูลสถานศึกษา</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <div
        v-if="!miniVariant && !searchQuery"
        class="caption grey--text text--darken-1 font-weight-bold ml-4 mb-2 mt-4 text-uppercase"
      >
        การจัดการระบบ
      </div>

      <template v-for="(item, i) in filteredItems">
        <v-list-group
          v-if="item.items && item.items.length > 0"
          :key="i"
          v-model="item.active"
          :prepend-icon="item.action"
          active-class="primary--text"
          class="custom-list-group mb-1"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">{{
                item.title
              }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(child, j) in item.items"
            :key="j"
            :to="child.to"
            class="pl-8 mb-1 rounded-lg"
            active-class="primary--text bg-active"
            link
          >
            <v-list-item-icon class="mr-3">
              <v-icon
                size="20"
                :color="$route.path === child.to ? 'primary' : 'grey lighten-1'"
                >{{ child.action }}</v-icon
              >
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-regular">{{
                child.title
              }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action v-if="child.badge">
              <v-chip x-small color="error" class="font-weight-bold">{{
                child.badge
              }}</v-chip>
            </v-list-item-action>
          </v-list-item>
        </v-list-group>

        <v-list-item
          v-else
          :key="i"
          :to="item.to"
          class="mb-1 rounded-lg"
          active-class="primary--text bg-active"
        >
          <v-list-item-icon>
            <v-icon>{{ item.action }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>

    <template v-slot:append>
      <div class="pa-2">
        <div class="d-flex justify-end px-2 mb-2" v-if="!expandOnHover">
          <v-btn icon small @click="toggleMiniVariant" color="grey">
            <v-icon>{{
              miniVariant ? "mdi-chevron-right" : "mdi-chevron-left"
            }}</v-icon>
          </v-btn>
        </div>

        <v-card
          flat
          class="grey lighten-4 rounded-lg pa-3 mb-2 text-center"
          v-if="!miniVariant"
        >
          <div class="d-flex text-center justify-space-between">
            <span class="caption grey--text font-weight-bold"
              >Line Group : กจ2</span
            >

            <div></div>
          </div>
          <div class="text-center pa-3">
            <v-img
              width="120"
              src="https://hrvec.ovec.go.th/HRvecfiles/ipa2.jpg"
              class="mx-auto mb-2"
              contain
            ></v-img>
          </div>
          version {{ $appVersion.version }}
        </v-card>

        <v-btn
          block
          depressed
          color="error"
          class="rounded-lg"
          :class="miniVariant ? 'px-0' : ''"
          @click="confirmLogout"
        >
          <v-icon :left="!miniVariant">mdi-logout-variant</v-icon>
          <span v-if="!miniVariant">ออกจากระบบ</span>
        </v-btn>
      </div>
    </template>

    <v-overlay :value="loading" absolute color="white" opacity="0.7">
      <v-progress-circular
        indeterminate
        color="primary"
        size="48"
      ></v-progress-circular>
    </v-overlay>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ModernSidebar",
  props: {
    expandOnHover: { type: Boolean, default: false }
  },
  data: () => ({
    loading: false,
    version: "Loading...",
    buildDate: null,
    drawer: true,
    miniVariant: false,
    searchQuery: "",
    user: {},
    filteredItems: [],
    // ข้อมูลเมนู (เหมือนเดิม แต่จัดกลุ่มใหม่ให้ชัดเจนขึ้นได้ถ้าต้องการ)
    items: [
      {
        action: "mdi-account-reactivate",
        title: "ระบบงานบุคคล",
        active: false,
        items: [
          {
            title: "ข้อมูลเกี่ยวกับบุคคล",
            action: "mdi-account",
            to: "/college/personnel_tem"
          },
          {
            title: "ข้อมูลคุณวุฒิการศึกษา",
            action: "mdi-school",
            to: "/college/personnel_education"
          },
          {
            title: "ข้อมูลประสบการณ์",
            action: "mdi-airplane",
            to: "/college/personnel_experience"
          },
          {
            title: "ข้อมูลประวัติการรับราชการ",
            action: "mdi-access-point-network",
            to: "/college/personnel_work_history"
          },
          {
            title: "ข้อมูลผลงาน รางวัล",
            action: "mdi-trophy-award",
            to: "/college/personnel_award"
          },
          {
            title: "ข้อมูลโทษ วินัย",
            action: "mdi-alarm-light",
            to: "/college/personnel_discipline"
          }
        ]
      },
      {
        action: "mdi-bluetooth-transfer",
        title: "ระบบการย้าย",
        active: false,
        items: [
          {
            title: "รายงานตัวย้ายกรณีปกติ",
            action: "mdi-account-circle",
            to: "/college/conditons_transfer_success"
          },
          {
            title: "สายการสอนประสงค์ย้ายออก",
            action: "mdi-account-circle",
            to: "/college/transference_personnel"
          },
          {
            title: "สายการสอนประสงค์ย้ายเข้า",
            action: "mdi-account-circle",
            to: "/college/transference_personnel_movein"
          },
          {
            title: "สายบริหาร",
            action: "mdi-account-circle",
            to: "/college/transference_manage_location"
          }
        ]
      },
      {
        action: "mdi-order-bool-descending-variant",
        title: "ระบบเงื่อนไขสาขาวิชาเอก",
        active: false,
        items: [
          {
            title: "ข้อมูลเงื่อนไขสาขาวิชาเอก",
            action: "mdi-source-branch",
            to: "/college/conditions_branch"
          },
          {
            title: "ประวัติข้อมูลเงื่อนไขสาขาวิชาเอก",
            action: "mdi-source-branch",
            to: "/college/history_conditions"
          }
        ]
      },
      {
        action: "mdi-human",
        title: "ระบบอัตรากำลัง",
        active: false,
        items: [
          {
            title: "ข้อมูลอัตรากำลังสถานศึกษา",
            action: "mdi-account-multiple",
            to: "/college/rate_workforce_g"
          }
        ]
      },
      {
        action: "mdi-account-supervisor-circle",
        title: "ระบบครูผู้ช่วย",
        active: false,
        items: [
          {
            title: "รับรายงานตัวครูผู้ช่วย",
            action: "mdi-account-star",
            to: "/college/manage_assistant_teacher"
          },
          {
            title: "ประเมินครูผู้ช่วย",
            action: "mdi-account-star",
            to: "/college/assistantcommitteequalified"
          }
        ]
      },
      {
        action: "mdi-account-supervisor-circle",
        title: "ระบบพนักงานราชการ",
        active: false,
        items: [
          {
            title: "รับรายงานตัว กรณี ย้าย",
            action: "mdi-account-star",
            to: "/college/gov_em/receive_govem"
          },

          {
            title: "ข้อมูลพนักงานราชการ กรอบอัตรากำลัง",
            action: "mdi-account-star",
            to: "/college/gov_em/government_employee"
          },

         {
            title: "ข้อมูลพนักงานราชการ และสัญญา",
            action: "mdi-account-star",
            to: "/college/gov_em/personnel_govem"
          },

          {
            title: "รายงานผลการประเมินการปฏิบัติงาน",
            action: "mdi-account-star",
            to: "/college/gov_em/assessment_govem"
          },
          {
            title: "การคำนวณค่าตอบแทนพนักงานราชการ",
            action: "mdi-account-star",
            to: "/college/gov_em/cal_compensation"
          }
        ]
      }
    ]
  }),
  computed: {
    ...mapState(["barColor"]), // ถ้าใช้ Vuex
    currentYear() {
      return new Date().getFullYear() + 543; // แปลงเป็น พ.ศ.
    },

    formattedBuildDate() {
      if (!this.$appVersion.buildDate) return "ไม่มีข้อมูล";

      try {
        const date = new Date(this.$appVersion.buildDate);
        return date.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        });
      } catch (error) {
        return "ไม่สามารถแสดงได้";
      }
    },

    environment() {
      return process.env.NODE_ENV === "production"
        ? "Production"
        : "Development";
    }
  },
  watch: {
    searchQuery(val) {
      this.filterMenuItems(val);
    }
  },
  async mounted() {
    this.loading = true;
    try {
      await this.userQuery();
      this.filteredItems = this.items; // Init items
    } catch (e) {
      console.log(e);
    }
    this.loading = false;

    const savedMini = localStorage.getItem("drawerMini");
    if (savedMini) this.miniVariant = savedMini === "true";
  },
  methods: {
    toggleMiniVariant() {
      this.miniVariant = !this.miniVariant;
      localStorage.setItem("drawerMini", this.miniVariant);
    },
    filterMenuItems(val) {
      if (!val) {
        this.filteredItems = this.items;
        return;
      }
      const query = val.toLowerCase();
      // Logic การกรอง (เหมือนเดิม)
      this.filteredItems = this.items
        .map(group => {
          const matchGroup = group.title.toLowerCase().includes(query);
          const filteredChildren = group.items
            ? group.items.filter(c => c.title.toLowerCase().includes(query))
            : [];

          if (matchGroup || filteredChildren.length > 0) {
            return {
              ...group,
              items:
                filteredChildren.length > 0 ? filteredChildren : group.items,
              active: true // Auto expand
            };
          }
          return null;
        })
        .filter(i => i !== null);
    },
    async userQuery() {
      try {
        let userSession = JSON.parse(sessionStorage.getItem("user")) || {};

        let result = await this.$http.post("admin.php", {
          user_name: userSession.user_name,

          ApiKey: "HRvec2021"
        });

        this.user = result.data || {};

        if (this.user.user_update === "0") {
          this.user.ApiKey = "HRvec2021";

          this.user.user_update = 1;

          await this.$http.post("user.update.php", this.user);

          // แสดงข้อความแจ้งเตือนแทนการ reload

          this.showSuccessMessage("ข้อมูลผู้ใช้ได้รับการอัปเดตแล้ว");
        }
      } catch (error) {
        console.error("Error in userQuery:", error);

        throw error;
      }
    },
    async confirmLogout() {
      Swal.fire({
        title: "ออกจากระบบ",

        text: "คุณต้องการออกจากระบบหรือไม่?",

        icon: "question",

        showCancelButton: true,

        confirmButtonColor: "#e74c3c",

        cancelButtonColor: "#95a5a6",

        confirmButtonText: "ออกจากระบบ",

        cancelButtonText: "ยกเลิก"
      }).then(result => {
        if (result.isConfirmed) {
          this.logout();
        }
      });
    },
    logout() {
      sessionStorage.clear();
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
/* Font Settings - ใช้ Sarabun เพื่อความเป็นทางการแต่ทันสมัย */
@import url("https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;500;700&display=swap");

.sidebar-container {
  font-family: "Sarabun", sans-serif !important;
  background-color: #ffffff !important;
  border-right: 1px solid #e0e0e0 !important; /* เส้นขอบบางๆ แทนเงาหนาๆ */

  /* Scrollbar สวยๆ */
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 4px;
  }
}

/* 1. Profile Area */
.profile-avatar {
  border: 2px solid #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.text-primary {
  color: #1976d2 !important; /* ปรับสีหลักตามธีมโรงเรียน/OVEC ได้ */
}

/* 2. Search Field */
.search-input {
  /* ปรับ Vuetify input ให้ดูคลีนขึ้น */
  ::v-deep .v-input__slot {
    min-height: 40px !important;
    padding: 0 16px !important;
  }
  ::v-deep .v-icon {
    font-size: 20px;
    opacity: 0.6;
  }
}

/* 3. List Item & Active States */
.v-list-item {
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #f5f7fa !important;
    transform: translateX(4px); /* ขยับนิดๆ ตอนเอาเมาส์ชี้ */
  }
}

/* Active State แบบสมัยใหม่: พื้นหลังสีจาง + ตัวหนังสือสีเข้ม */
.bg-active {
  background-color: #e3f2fd !important; /* สีฟ้าจางๆ */
  color: #1565c0 !important;
  font-weight: 600;

  &::before {
    opacity: 0 !important; /* ปิด Overlay เดิมของ Vuetify */
  }

  /* แถบสีด้านซ้าย (Optional indicator) */
  border-left: 4px solid #1976d2;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

/* ปรับแต่ง List Group */
.custom-list-group {
  ::v-deep .v-list-group__header {
    padding-left: 12px !important;

    &.v-list-item--active {
      color: #1976d2;
    }
  }
}

/* ลดขนาดไอคอนให้ดูแพงขึ้น */
.v-icon {
  font-size: 22px !important;
}
</style>
